import { render } from "./LostPassword.vue?vue&type=template&id=713a8494&scoped=true"
import script from "./LostPassword.vue?vue&type=script&lang=ts"
export * from "./LostPassword.vue?vue&type=script&lang=ts"

import "./LostPassword.vue?vue&type=style&index=0&id=713a8494&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-713a8494"

export default script